import { Box } from '@mui/material';
import BackgroundImage from '../../assets/images/Background.png'; 

const Background = ({ children }) => {
  return (
    <Box
      sx={{
        backgroundImage: `url(${BackgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        overflowX: 'auto',
        padding: '1rem',
      }}
    >
      {children}
    </Box>
  );
};

export default Background;
